<script>
import { defineComponent as _defineComponent } from "vue";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, inject, onBeforeUnmount } from "vue";
import {
  useMagicEmitter
} from "@maas/vue-equipment/plugins";
import { MagicCommandInstanceId } from "./../symbols";
import { useCommandState } from "../composables/private/useCommandState";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicCommandRenderer",
  setup(__props) {
    const instanceId = inject(MagicCommandInstanceId, "");
    const emitter = useMagicEmitter();
    if (!instanceId) {
      throw new Error(
        "MagicCommandRenderer must be nested inside MagicCommandProvider"
      );
    }
    const elRef = ref(void 0);
    const { initializeState } = useCommandState(instanceId);
    const state = initializeState();
    function enterCallback(payload) {
      if (typeof payload === "string" && payload === instanceId) {
        state.renderer = elRef.value;
      }
    }
    emitter.on("enter", enterCallback);
    onBeforeUnmount(() => {
      emitter.off("enter", enterCallback);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(
        "div",
        {
          ref_key: "elRef",
          ref: elRef,
          class: "magic-command-renderer"
        },
        null,
        512
        /* NEED_PATCH */
      );
    };
  }
});
</script>

<style>
.magic-command-renderer {
  position: relative;
  width: var(--magic-command-renderer-width, 100%);
  height: var(--magic-command-renderer-height, 100%);
}

.magic-command-content--fade-enter-active {
  animation: fade-in 2000ms ease;
}

.magic-command-content--fade-leave-active {
  animation: fade-out 2000ms ease;
}
</style>
